import React, { useEffect } from 'react'
import { useCountUp } from 'react-countup'
import PropTypes from 'prop-types'

import { Text } from './..'

const ColoredCountUp = ({
  value,
  prefix,
  suffix,
  formatter = v => v,
  absolute = true,
  countAtMount,
  className,
  controlledColor,
  weight = 'bold',
}) => {
  const incValue = parseFloat(value, 10)
  const startValue =
    typeof countAtMount === 'number'
      ? countAtMount
      : countAtMount
      ? 0
      : incValue
  const {
    countUp,
    start: startCount,
    update: updateCount,
  } = useCountUp({
    start: startValue,
    end: incValue,
    duration: 1,
  })

  useEffect(() => {
    updateCount(incValue)
  }, [incValue]) // eslint-disable-line

  useEffect(() => {
    startCount()
  }, []) // eslint-disable-line

  const countUpValue = parseFloat(countUp, 10)
  const display = absolute
    ? formatter(Math.abs(countUpValue))
    : formatter(countUpValue)
  const color = controlledColor
    ? controlledColor
    : countUpValue > 0
    ? 'green'
    : countUpValue < 0
    ? 'red'
    : 'white'

  return (
    <Text
      size='m'
      color={color}
      weight={weight}
      element='span'
      className={className}
    >
      {`${prefix ?? ''}${display}${suffix ?? ''}`}
    </Text>
  )
}

ColoredCountUp.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  prefix: PropTypes.string,
  suffix: PropTypes.string,
  controlledColor: PropTypes.string,
  className: PropTypes.string,
  formatter: PropTypes.func,
  absolute: PropTypes.bool,
  countAtMount: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  weight: PropTypes.oneOf(['light', 'regular', 'semibold', 'bold']),
}

export default ColoredCountUp
